/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import './EditInsuranceModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import _ from 'lodash';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';

import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import Compdirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allInsurerTypes: any;
  allPolicyTypes: any;
  callBackGetData: (data: any) => void;
  editedData: any;
  trans?: any;
}

const EditInsuranceModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allInsurerTypes,
  allPolicyTypes,
  editedData,
  trans,
}: ModalProps) => {
  const [amount, setAmount] = useState(editedData?.amount);
  const [policyNumber, setPolicyNumber] = useState(editedData?.policy_number);

  const [category, setCategory] = useState(editedData?.category);

  const [policyTypeName, setPolicyTypeName] = useState(
    editedData?.policytype?.name,
  );
  const [policyTypeId, setPolicyTypeId] = useState(editedData?.policytype?.id);

  const [insurerTypeName, setInsurerTypeName] = useState(
    editedData?.insurers?.name,
  );
  const [insurerTypeId, setInsurerTypeId] = useState(editedData?.insurers?.id);

  const [startDate, setStartDate] = useState<any>(editedData?.start_date);
  const [endDate, setEndDate] = useState<any>(editedData?.expiry_date);

  const [insuranceDocuments, setInsuranceDocuments] = useState(
    editedData?.emp_insurance_documents[0]?.document,
  );
  const [insuranceDocumentsPath, setInsuranceDocumentsPath] = useState(
    editedData?.emp_insurance_documents[0]?.document,
  );

  const [removed, setRemoved] = useState(false);
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');

  const handleEndDate = (date: any) => {
    setEndDate(date);
  };

  const handleStartDate = (date: any) => {
    setStartDate(date);
  };

  const insuranceDocumentsUpload = (e: any) => {
    const _file: any = e.target.files[0];

    if (_file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);

      setInsuranceDocuments(_file);
      setInsuranceDocumentsPath(image_as_base64);
    } else {
      setInsuranceDocuments(_file);
      setIsPDF(true);
      setPDFName(_file?.name);
    }
  };
  const handleInsurerType = (insurerName: any) => {
    const getInsurer = _.filter(allInsurerTypes, function (insurer: any) {
      return insurer.name === insurerName;
    });
    if (getInsurer.length) {
      const insurer_type = getInsurer[0];
      setInsurerTypeId(insurer_type.id);
      setInsurerTypeName(insurerName);
    }
  };

  const handlePolicyType = (policyName: any) => {
    const getPolicy = _.filter(allPolicyTypes, function (policy: any) {
      return policy.name === policyName;
    });
    if (getPolicy.length) {
      const policy_type = getPolicy[0];
      setPolicyTypeId(policy_type.id);
      setPolicyTypeName(policyName);
    }
  };
  const handleSubmit = () => {
    callBackGetData({
      id: editedData?.id,
      insurer: insurerTypeId,
      policy_type: policyTypeId,
      policy_number: policyNumber,
      start_date: startDate,
      end_date: endDate,
      category: category,
      amount: amount,
      attachments:
        typeof insuranceDocuments === 'string' || !insuranceDocuments
          ? undefined
          : insuranceDocuments,
      removed: removed,
    });
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="687px"
      modalWidth="550px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Edit Insurance') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={3}
          style={{
            marginTop: '15px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Insure')}
              options={_.map(allInsurerTypes, (insurer: any) => {
                return insurer.name;
              })}
              value={insurerTypeName}
              onChange={(event: any, newValue: any) => {
                handleInsurerType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Policy Type')}
              options={_.map(allPolicyTypes, (policy: any) => {
                return policy.name;
              })}
              value={policyTypeName}
              onChange={(event: any, newValue: any) => {
                handlePolicyType(newValue);
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Policy Number')}
              placeholder={trans('Write Policy Number')}
              value={policyNumber}
              onChange={(e: any) => setPolicyNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Category')}
              placeholder={trans('Write Category')}
              value={category}
              onChange={(e: any) => setCategory(e.target.value)}
            />
          </Grid>

          <Grid item xs={6}>
            <DatePickerInput
              width="100%"
              label={trans('Start Date')}
              defaultValue={editedData?.start_date}
              value={startDate}
              onChange={(newValue: any) => {
                handleStartDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickerInput
              width="100%"
              label={trans('End Date')}
              defaultValue={editedData?.expiry_date}
              value={endDate}
              onChange={(newValue: any) => {
                handleEndDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="number"
              label={trans('Amount')}
              placeholder={trans('Write Amount')}
              value={amount}
              onChange={(e: any) => setAmount(e.target.value)}
            />
          </Grid>

          <Grid item xs={5}>
            <DropAndSelect
              upload={insuranceDocumentsUpload}
              src={insuranceDocumentsPath}
              isAttachmentSigned={true}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setIsPDF(false);
                setPDFName('');
                setInsuranceDocumentsPath('');
                setRemoved(true);
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default EditInsuranceModalPresenter;
